//libs
import { styled } from '@nykaa/ui-components';
import { keyframes } from '@emotion/core';

//components
import BaseIcon from 'shared/layouts/Wishlist/components/PriceDrop/Icon';
import BaseIO from 'shared/components/IOElement';

export const Container = styled.div`
  width: 100%;
  overflow: hidden;
`;

export const PriceComponent = styled.div`
  white-space: nowrap;
  width: fit-content;
  height: 20px;
  ${({ theme }) => theme.typography.bodySmall};
  ${({ theme }) =>
    `background-color: ${theme.colors.positive10};
     color: ${theme.colors.positive};
     margin: 0 ${theme.spacing.spacing40} ${theme.spacing.spacing40};
     padding: ${theme.spacing.spacing10};
     border-radius: ${theme.borders.radius10};
    `};
`;

export const Price = styled.span`
  display: inline-block;
  ${({ theme }) => theme.typography.labelMedium};
`;

const line = keyframes`
    from {
      width: 0px;
      top: 4px;
      left: 2px;
    }
    to {
      width: 6px;
      top: 6px;
      left: 1px;
    }
`;

const stroke = keyframes`
    from {
      stroke-dasharray: 11;
      opacity: 1;
    }
    to {
      stroke-dasharray: 21;
      opacity: 1;
    }
`;

const arrow = keyframes`
    from {
      opacity: 0;
    }
    to {    
      opacity: 1;
    }
`;

export const IconWrapper = styled.div`
  height: 16px;
  width: 16px;
  position: relative;
  display: inline-block;

  &:before {
    content: '';
    position: absolute;
    height: 1.2px;
    transform: rotate(45deg);
    width: 0px;
    background: ${({ theme }) => theme.colors.positive};
    animation: ${line} 0.5s linear forwards;
  }

  ${({ theme }) => `margin-left: ${theme.spacing.spacing10};`};
`;

export const Icon = styled(BaseIcon)`
  width: 16px;
  height: 16px;
  animation: ${stroke} 1s 0.6s linear forwards;
  opacity: 0;
  vertical-align: bottom;

  .arrow {
    animation: ${arrow} 0.5s 1.6s linear forwards;
    opacity: 0;
  }
`;

export const IOElement = styled(BaseIO)`
  display: inline-block;
`;
